import React, { useState, useEffect } from "react"
import { CSSTransition } from 'react-transition-group';
import InnerHTML from 'dangerously-set-html-content'

import sessionStorageWrapper from 'util/SessionStorageWrapper'
import ListicleVoteButtons from "./ListicleVoteButtons"
import { DropdownButton } from "./components/DropdownButton"
// import WistiaListener from "./WistiaListener"
import {legacyImageURL} from "components/LegacyImage"
import IntersectionVisible from 'components/IntersectionVisible'
import ReactCompareImage from "steps/shared/ReactCompareImage"
import { scrollToTopOfEditorialStep } from "services/break"

import PlaceHolderImage from "components/PlaceholderImage"
import Arrow from 'images/inline/listicle-step-arrow-right.svg'

import { userTypeEnum } from "services/user"

import analytics from "global/AnalyticsData"


import "./listicle.scss"

const displayFormats = {
    default: "slideshow",
    slideshow: "slideshow",
    list: "list",
}

function sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

export const BodyCopy = ({bodyCopy, order}) => {
    // The editorial team hard-coded some sign-up copy in many/most articles. This removes it.
    let tmp = "" + bodyCopy
    const reg = /(\bNot a member\b(.*)\bfamily and friends\b\!)/
    tmp = tmp.replace(reg, "")

    return (
        <div className="content-item body-copy"
                style={{order: order}}
                dangerouslySetInnerHTML={{ __html: tmp, }}
        />
    )
}

export const Button = ({url, bgColor, buttonText, order, onClick}) => {
    return (
        <div className="content-item button">
            <a href={url}
                style={{
                    background: bgColor,
                    color: "#fff",
                    order: order
                }}
                target="_blank"
                rel="noopener noreferrer"
                onClick={onClick}>
                { buttonText }
            </a>
        </div>
      )
}

export const EmbedCode = ({embedCode, order}) => {

    useEffect(() => {
        // triggers instagram's library to look for posts to embed
        // needed when an instagram embed isn't on the page when the instagram library loads initially
        window && window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process()
    }, [embedCode])

    const handleVideoPlayed = (videoId, videoName) => {
        console.log(`handleVideoPlayed ${videoId} ${videoName}`)
    }

    const handleVideoWatched = (videoId, videoName) => {
        console.log(`handleVideoWatched ${videoId} ${videoName}`)
    }

    return (
        <div className="content-item embed"
                style={{order: order}}
        ><InnerHTML html={embedCode} />
        {/* <WistiaListener embedCode={embedCode} onVideoPlayed={handleVideoPlayed} onVideoWatched={handleVideoWatched} /> */}
        </div>
    )
}
export const Image = ({image, order}) => {

    return (
        <div className="content-item image-contain" style={{order: order}}>
        {image && image.id && (
          <PlaceHolderImage src={`${process.env.SITE_ASSET_URL}/${image.id}`} height={745} width={745} />
        )}
      </div>

    )
}

export const ImageComparison = ({leftImageUrl, rightImageUrl, order}) => {

    return (
        <div className="content-item image-compare" style={{order: order}}>
            <ReactCompareImage leftImage={leftImageUrl} rightImage={rightImageUrl} />
        </div>
    )
}

export const OldBodyCopy = ({content, order}) => {
    return (
        <div className="content-item old-body-copy"
                style={{order: order}}
        ><InnerHTML html={content} />
        </div>
    )
}

// TODO: The only reason we pass step is for analytics.. which should be passed up somehow
export const ListicleContent = ({step, item, content}) => {
    // console.log(content.type)
    switch (content.type) {
        case "BodyCopy": {
            return (<BodyCopy
                        bodyCopy={content.bodyCopy}
                        order={content.displayOrder}
                    />)
        }
        case "Button": {
            return (<Button
                        url={content.url}
                        bgColor={content.bgColor}
                        buttonText={content.buttonText}
                        order={content.displayOrder}
                        onClick={() => {
                            analytics.stepEvent("step_interaction_listicle_button_click", step, {
                                result_id: content.id,
                                result: content.buttonText + " | " + content.url,
                            })
                        }}
                    />)
        }
        case "EmbedCode": {
            return (
                <EmbedCode embedCode={content.embedCode} order={content.displayOrder}/>
            )
        }
        case "Image": {
            return (
                <Image image={content.image} order={content.displayOrder}/>
            )
        }
        case "ImageComparison": {
            return (
                <ImageComparison leftImageUrl={legacyImageURL(content.leftImage)} rightImageUrl={legacyImageURL(content.rightImage)} order={content.displayOrder}/>
            )
        }
        case "Menu" :
        return (<DropdownButton
                        text={content.text}
                        items={content.items}
                        order={content.displayOrder}
                        onClick={(buttonText, url) => {
                            analytics.stepEvent("step_interaction_listicle_button_click", step, {
                                result_id: content.id,
                                result: buttonText + " | " + url,
                            })
                        }}/>)
        case "OldBodyCopy": {
            return (
                <OldBodyCopy content={content.content} order={content.displayOrder}/>
            )
        }
        case "Subhead": {
            return <h2 className="content-item subhead" style={{order: content.displayOrder}}>{content.subHead}</h2>
      }
        default:
            return <p>Unhandled: {content.type} </p>
    }
}

const isEmpty = (str) => {
    return (!str || 0 === str.length);
}

export const ListicleContents = ({step, item, voteButtonComponent}) => {

    let listicleContents = item.listicleContents

    // Legacy content won't have layout settings for us to use.
    // if there's an image, we can leverage that to determine layout.
    // otherwise, everything will get stacked in the BOTTOM row.
    const legacyImageWithNoLayout = listicleContents.findIndex((current) => {
        return (current.type === "Image") && isEmpty(current.layoutRow)
    })

    // If we have an image and no layout info, use the image to determine layout
    if (legacyImageWithNoLayout != -1) {
        const useMiddleRow = ( listicleContents.find(element => ((element.type === "Image" ) && (element.imageType !== "HORIZONTAL"))) != -1)

        if (useMiddleRow) {
            listicleContents.forEach((current, i, arr) => {
                if (current.type === "Image") {
                    if (isEmpty(item.layoutRow)) {
                        arr[i].layoutRow = "MIDDLE"
                        arr[i].layoutColumn = "LEFT"
                    }
                } else {
                    if (isEmpty(item.layoutRow)) {
                        arr[i].layoutRow = "MIDDLE"
                        arr[i].layoutColumn = "RIGHT"
                    }
                }
            })
        }
    }

    // Listicle images in beaker have a property called imageType that can affect layout.
    // Get the imageType so we can later append it to .row-middle
    const extraCss = listicleContents.reduce((accumulator, current) => {
        if (current.type === "Image") {
            return accumulator + " " + current.imageType
        }
        return accumulator
    }, "")


    // Separate listicleContents into their respective rows.
    // We reduce the array of listicleContents into an object with 3 keys, TOP, MIDDLE, BOTTOM.
    // Each key points to an array of content items.
    const validLayoutRows = ["TOP", "MIDDLE", "BOTTOM"]

    const orderedContents = listicleContents.reduce((current, item, i) => {
        // content may not have a definition
        if (!validLayoutRows.includes(item.layoutRow)) {
            item.layoutRow = "BOTTOM"
        }

        current[item.layoutRow].push(item)

        return current

    }, {
        "TOP": [],
        "MIDDLE": [],
        "BOTTOM": [],
    })

    // console.log(orderedContents)

    return (
        <div className={`listicle-item-contents`}>
            { (orderedContents["TOP"].length > 0) &&
                <div className="row row-top">
                    {
                        orderedContents["TOP"].map((content, i) => {
                            return <ListicleContent step={step} content={content} key={i} />
                        })
                    }
                </div>
            }
            { (orderedContents["MIDDLE"].length > 0) &&
                <div className={`row row-middle ${extraCss}`}>
                    <div className="col col-left">
                    {
                        orderedContents["MIDDLE"].map((content, i) => {
                            if (content.layoutColumn === "LEFT") {
                                return <ListicleContent step={step} content={content} key={i} />
                            }
                        })
                    }
                    </div>
                    <div className="col col-right">
                    {
                        orderedContents["MIDDLE"].map((content, i) => {
                            if (content.layoutColumn !== "LEFT") {
                                return <ListicleContent step={step} content={content} key={i} />
                            }
                        })
                    }
                    </div>
                </div>
            }
            { (orderedContents["BOTTOM"].length > 0) &&
                <div className="row row-bottom">
                    {
                        orderedContents["BOTTOM"].map((content, i) => {
                            return <ListicleContent step={step} content={content} key={i} />
                        })
                    }
                </div>
            }
            { item.hasVoting &&
                <div className="row row-voting">
                    { voteButtonComponent }
                </div>
            }

        </div>
    )
}

const ListiclePanel = ({ step, item, i, currentPosition, totalItems, backgroundImage, handlePrevClick, handleNextClick, voteButtonComponent, skipButton, nextStepButton }) => {
    return (
        <>
        { item &&
        <div className={`step-content ${step.listicle.displayFormat === displayFormats.list ? "list-format" : ""} ${step.listicle.displayFormat === displayFormats.slideshow ? "with-shadow" : ""} db-react-slide `}>
            {step.listicle.displayFormat === displayFormats.default && <div className="quiz__progress">
                <span className="progress-label">List
                </span>
                <span className="quiz__progress-number">
                  {currentPosition} of {totalItems}
                </span>
                <ul className="quiz__progress-dots">
                  {Array.from({ length: totalItems }).map((_, i) => {
                    return <li key={i} className={`${i + 1 === currentPosition ? "active" : ""}`}></li>
                  })}
                </ul>
                <ul className="inner-arrows">
                  <li>
                    <button type="button" className={`inner-prev`} onClick={handlePrevClick} aria-label="Previous"></button>
                  </li>

                 <li>
                    <button type="button" className={`inner-next`} onClick={handleNextClick} aria-label="Next"></button>
                  </li>
                </ul>
            </div>}
            {item.subhead && (
                <h2
                  className="step-content__title"
                  dangerouslySetInnerHTML={{
                    __html: `${i + 1}. ${item.subhead}`,
                  }}
                />
            )}

            {item.listicleContents && (
                <ListicleContents
                    step={step}
                    item={item}
                    voteButtonComponent={voteButtonComponent}
                />
            )}
            {   
                step.listicle.displayFormat !== displayFormats.default &&
                i === totalItems - 1 &&
                skipButton
            }
            {   
                step.listicle.displayFormat === displayFormats.default &&
                skipButton
            }
            {
                step.listicle.displayFormat === displayFormats.default &&
                <div className='arrow'>
                    <Arrow onClick={handleNextClick} />
                </div>
            }
        </div>
                    
        }
        </>
    )
}


const ListicleStep = ({ breakId, step, onAwardPoints, onEngage, userType, service, skipButton, nextStepButton }) => {

    // console.log(step);

    const [state, setState] = useState({
        position: 0,
        showPanel: true,
        scrollDirection: "forward"
    })

    const [voteData, setVoteData] = useState({})

    // allows us to filter list items based on a previous PQ result
    const [listItems, setListItems] = useState(step.listicle.items)

    const [videoWatched, setVideoWatched] = useState(false);

    const animationDuration = 600;  // same value set in the CSS transtion rule
                                    // we double it in our code below to account for entering + leaving

    const pqResultId = sessionStorageWrapper.getItem(`${breakId}_pq_result_id`, undefined)

    useEffect(() => {
        filterListicleItems()
    }, [pqResultId])

    useEffect(() => {
        const asyncWrapper = async () => {
            const response = await service.get('vote', {listicleId : step.listicle.id })
            if (response.status === 200) {
                const body = await response.json()


                // turn the api result (array) into a map
                const voteDataObj = body.listicleItemVotes.reduce((result, item, i) => {
                    result[item.itemId] = item
                    return result
                }, {})

                setVoteData(voteDataObj)
            }
        }

        service && step && asyncWrapper()

    }, [service, step])

    const handleNextClick = async () => {
        setState({
            position: state.position,
            showPanel: false,
            scrollDirection: "forward"
        })
        // console.log(`next click ${state.position}`)
        // this gives the CSS animation time to exit
        await sleep(animationDuration + 100)
        scrollToTopOfEditorialStep('auto')      // TODO: This obv won't work for sponsored

        // console.log(`next click sleep done`)
        // points are awarded after the user clicks next to go to the next step
        if (state.position === 0) {
            onAwardPoints()
            onEngage()
            setVideoWatched(true);
            console.log(videoWatched);
        }

        if (state.position == (listItems.length - 1)) {
            setState({
                position: 0,
                showPanel: true,
                scrollDirection: "forward"
            })
        } else {
            setState({
                position: state.position + 1,
                showPanel: true,
                scrollDirection: "forward"
            })
        }

        if (typeof window !== `undefined`) {
            window.dataLayer.push({
                event: "step_interaction_listicle_arrow_click",
            })

            analytics.stepEvent("step_interaction_listicle_arrow_click", step, {})
        }

    }

    const handlePrevClick = async () => {

        // console.log(`prev click ${state.position}`)

        // trigger the fade out animation `showPanel: false`
        setState({
            position: state.position,
            showPanel: false,
            scrollDirection: "backward"
        })
        // await sleep((animationDuration * 2) + 100)
        // await sleep(animationDuration)
        await sleep(animationDuration + 100)

        // trigger the fade in animation on the next item `showPanel: true`
        if (state.position == 0) {
            setState({
                position: listItems.length - 1,
                showPanel: true,
                scrollDirection: "backward"
            })
        } else {
            setState({
                position: state.position - 1,
                showPanel: true,
                scrollDirection: "backward"
            })
        }

        analytics.stepEvent("step_interaction_listicle_arrow_click", step, {})

    }

    const handleIsOnScreen = (isIntersecting) => {
        if (isIntersecting) {
            filterListicleItems()
        }

    }

    const handleIsOnScreenVertical = (isIntersecting) => {
        if (isIntersecting) {
            onAwardPoints()
            onEngage()
            analytics.stepEvent("step_interaction_listicle_scroll_complete", step, {})
            setVideoWatched(true);
            console.log(videoWatched);
        }
    }

    const handleOnVote = (itemId, selection) => {
        let tmp = voteData[itemId]
        tmp.selection = selection
        // tomfoolery.
        if (selection === "UP") {
            tmp.upvotes = tmp.upvotes + 1
        }
        if (selection === "DOWN") {
            tmp.downvotes = tmp.downvotes + 1
        }

        voteData[itemId] = tmp

        console.log(voteData)
        setVoteData(voteData)
    }

    // on sponsored breaks listicle items can be filtered down based on answers to a previous steps
    const filterListicleItems = async () => {
        let newListicleItems = step.listicle.items

        //
        // if (userType === userTypeEnum.REGISTERED) {
            try {
                // on sponsored breaks listicle items can be filtered down based on answers to a previous steps
                const pqResultId = sessionStorageWrapper.getItem(`${breakId}_pq_result_id`, undefined)
                //filter listicle items based on pqresultid
                newListicleItems = step.listicle.items.filter(item => {
                    const hide = item.dynamics && item.dynamics.some(dynamic => dynamic.value === pqResultId)
                    if (hide) {
                        return false
                    }
                    return true
                })
            } catch (e) {
                console.log(e)
            }
        // }

        // the editorial team hard-coded footers in content asking people to sign up.
        // they did this is hundreds of breaks.
        // we remove those programmatically at render time.
        // there are 2 cases:
        // 1) signup copy (bodyCopy) is the only content item in listicleContents[]
        //      when we remove that content we also remove the parent item (which is now empty of contents)
        //      that's what's happening below
        // 2) signup copy is one of several content items in listicleContents[]
        //      we do nothing and let <ListicleContent> just not display it later because
        //      there are other listicleContents items that should get displayed
        newListicleItems = newListicleItems.filter(item => {
            // console.log(item)
            return item.listicleContents.some(content => {
                // this is awful and I'm sorry
                // !content.bodyCopy - anything that isn't a bodyCopy element is good
                // bodyCopy and not "not a memeber" is also good
                return !content.bodyCopy || (content.bodyCopy && (content.bodyCopy.indexOf("Not a member of Dailybreak yet") === -1))
            })

        })

        if (newListicleItems.length !== step.listicle.items.length) {
            setListItems(newListicleItems)
        }


    }


    // console.log(`listItems`, listItems)
    // console.log(`state`, state)
        const item = listItems[state.position]
        let itemVoteData = undefined
        if (item && voteData[item.id]) {
            itemVoteData = voteData[item.id]
        }
        // console.log(`voteData`, voteData[item.id])
        const voteButtonComponent =
            item &&
            item.hasVoting &&
            <ListicleVoteButtons
                listicleId={ step.listicle.id }
                itemId={ item.id }
                upVotetxt={item.upvoteBtnText}
                downVotetxt={item.downvoteBtnText}
                upVoteIcon={item.upvoteBtnIcon}
                downVoteIcon={item.downvoteBtnIcon}
                selection={itemVoteData ? itemVoteData.selection : undefined}
                upvotes={itemVoteData ? itemVoteData.upvotes : undefined}
                downvotes={itemVoteData ? itemVoteData.downvotes : undefined}
                onVote={handleOnVote}
            />

    const voteButtonComponentVertical = (listicleId) => {
        let itemVoteData = undefined
        if (step.listicle.items[listicleId] && voteData[step.listicle.items[listicleId].id]) {
            itemVoteData = voteData[step.listicle.items[listicleId].id]
        }
        return (
            <ListicleVoteButtons
                listicleId={ step.listicle.id }
                itemId={ step.listicle.items[listicleId].id }
                upVotetxt={step.listicle.items[listicleId].upvoteBtnText}
                downVotetxt={step.listicle.items[listicleId].downvoteBtnText}
                upVoteIcon={step.listicle.items[listicleId].upvoteBtnIcon}
                downVoteIcon={step.listicle.items[listicleId].downvoteBtnIcon}
                selection={itemVoteData ? itemVoteData.selection : undefined}
                upvotes={itemVoteData ? itemVoteData.upvotes : undefined}
                downvotes={itemVoteData ? itemVoteData.downvotes : undefined}
                onVote={handleOnVote}
            />
        )
    } 

    if (!step.listicle.displayFormat) {
        step.listicle.displayFormat = displayFormats.slideshow
    }

    return (
        <>
        <section className={`${step.backgroundImage ? "sponsored" : ""} listicle-step db-react-slideshow ${state.scrollDirection} ${step.backgroundImage && step.listicle.displayFormat === displayFormats.slideshow ? "slideshow" : ""} ${step.listicle.displayFormat === displayFormats.list ? "with-shadow narrower": ""} format-${step.listicle.displayFormat}`}>
            {step.listicle.displayFormat === displayFormats.list ? (
                <>
                <IntersectionVisible active={true} options={{
                    threshold: 0.4,
                    }} onIntersect={handleIsOnScreen}>
                    <div className="visible-handler-top" style={{height: '1px'}}>&nbsp;</div>
                </IntersectionVisible>
                {listItems.map((_, index) => (
                    <ListiclePanel
                        key={index}
                        step={step}
                        item={listItems[index]}
                        i={index}
                        currentPosition={index + 1}
                        totalItems={listItems.length}
                        backgroundImage={step.backgroundImage}
                        voteButtonComponent={voteButtonComponentVertical(index)}
                        skipButton={skipButton}
                    />
                ))}
                <IntersectionVisible active={true} options={{
                    threshold: 0.4,
                }} onIntersect={handleIsOnScreenVertical}>
                    <div className="visible-handler-bottom" style={{height: '10px'}}>&nbsp;</div>
                </IntersectionVisible>
       
                { nextStepButton }
                </>
            ) : (
                <CSSTransition
                    in={ state.showPanel }
                    timeout={animationDuration }
                    classNames="db-react-slide"
                    unmountOnExit={false}
                >
                    <div>
                        <IntersectionVisible active={true} options={{
                            threshold: 0.4,
                        }} onIntersect={handleIsOnScreen}>


                                <ListiclePanel 
                                    step={step}
                                    item={listItems[state.position]}
                                    i={state.position}
                                    currentPosition={state.position + 1}
                                    totalItems={listItems.length}
                                    backgroundImage={step.backgroundImage}
                                    handlePrevClick={handlePrevClick}
                                    handleNextClick={handleNextClick}
                                    voteButtonComponent={voteButtonComponent}
                                    skipButton={skipButton}
                                />
                            
                        </IntersectionVisible>
                
                        <div className="next-arrow-slideshow">
                            {nextStepButton}
                        </div>
                    </div>
                </CSSTransition>
            )}
        </section>
        </>
    )
}


export default ListicleStep
